// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,
    //apiUrl: "https://facilitic-backend-fduyidclpa-uc.a.run.app/api/",
    apiUrl: "https://facilitic-backend-master-fduyidclpa-uc.a.run.app/api/",
    auth: {
        domain: "factilitic.us.auth0.com",
        clientId: "KckCC0QQm2QkmF8DQnGkhP64qj0Lmnjr",
        audience: "https://facilitic.cl/api",
        redirectUri: window.location.origin,
    },
    logoutUrl: window.location.origin,
};

//ruta de acceso dev https://storage.googleapis.com/facilitic-dev/index.html

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
